/**
 * Cor de acento de uma sala (definida livremente no cadastro, ex: '#000000'
 * para a Sala Atlético) usada como cor de TEXTO/BORDA em vários lugares.
 * Isso quebra no modo escuro quando a cor cadastrada é escura demais —
 * texto preto sobre fundo já escuro fica ilegível. Aqui calculamos a
 * luminância da cor e, se ela for baixa demais para servir de texto sobre
 * fundo escuro, usamos branco no lugar. A cor original continua sendo usada
 * normalmente como fundo/acento (onde opacidade e não legibilidade de texto
 * é o que importa).
 */
function luminanciaRelativa(hex: string): number {
  const limpo = hex.replace('#', '');
  const bytes = limpo.length === 3
    ? limpo.split('').map(c => parseInt(c + c, 16))
    : [0, 2, 4].map(i => parseInt(limpo.slice(i, i + 2), 16));
  const [r, g, b] = bytes.map(v => (Number.isNaN(v) ? 0 : v) / 255);
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

/** Cor de texto/borda segura para exibir `corSala` sobre um fundo escuro. */
export function corSalaParaTexto(corSala: string, temaEscuro: boolean): string {
  if (!temaEscuro) return corSala;
  return luminanciaRelativa(corSala) < 0.35 ? '#ffffff' : corSala;
}
